import React from 'react';

function PrivacyPage() {
  return (
    <div className="page legal-page">
      <h2>Privacidad y Protección de Datos</h2>
      <p>
        En QueComo se procesan datos necesarios para autenticación, personalización de menús y funcionamiento general
        de la app.
      </p>
      <p>
        No comercializamos información personal con terceros. Los datos se usan para brindar el servicio y mejorar la
        experiencia de uso.
      </p>
      <p>
        Se aplican medidas razonables de seguridad para proteger la información almacenada, aunque ningún sistema
        puede garantizar riesgo cero.
      </p>
      <p>
        Para consultas sobre privacidad, eliminación o actualización de datos, escribinos a info@qia.com.ar.
      </p>
    </div>
  );
}

export default PrivacyPage;
